<ig-card class="event-card"
         [picture]="tour.image"
         alt="itinerary picture"
         (click)="showTourDetail($event)">

    <div #card detail [style.background]="titleBgColor">
        <div #title class="ig-title ellipsis">{{tour.title||tour.name}}</div>
    </div>
</ig-card>

<div class="tour-card-mask" *ngIf="isLoading"></div>
<ig-spinner class="tour-card-spinner" *ngIf="isLoading"></ig-spinner>

<div #description (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()" (click)="showTourDetail($event)"
     class="tour-description" role="button" aria-label="view itinerary details">
    <div *ngIf="isShowDescription&&tour.description" (click)="showTourDetail($event)">{{tour.description.length>150?tour.description.substr(0,150)+'...':tour.description}}</div>
</div>



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/trip/tour.card/visitor.tour.card.component.html